import React from "react";
import { Filter } from "lucide-react";
import { FilterModalProps } from "./types";
import ModalOverlay from "./components/ModalOverlay";
import ModalHeader from "../Modal/ModalHeader";
import ModalInput from "./components/ModalInput";
import ModalSelect from "./components/ModalSelect";
import ModalActions from "./components/ModalActions";

const defaultGridClassName =
  "grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3";

const FilterModal: React.FC<FilterModalProps> = ({
  isOpen,
  onClose,
  fields,
  onFieldChange,
  onSearch,
  onClear,
  title = "Filtros",
  errors = {},
  gridClassName = defaultGridClassName,
}) => {
  if (!isOpen) return null;

  const hasFilters = fields.some((field) => field.value.trim() !== "");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <ModalOverlay onClose={onClose} />

      <div className="relative z-10 w-full max-w-4xl rounded-lg bg-white shadow-xl">
        <ModalHeader
          title={title}
          onClose={onClose}
          icon={<Filter size={20} className="text-primary" />}
          padding="p-4"
        />

        <div className="p-6">
          <div className="space-y-6">
            <div className={gridClassName}>
              {fields.map((field) => (
                <div key={field.name}>
                  <label className="mb-2 block text-sm font-medium text-neutral-700">
                    {field.label}
                  </label>
                  {field.type === "select" ? (
                    <ModalSelect field={field} onFieldChange={onFieldChange} />
                  ) : field.type === "date" ? (
                    <input
                      type="date"
                      value={field.value}
                      onChange={(e) =>
                        onFieldChange(field.name, e.target.value)
                      }
                      className="w-full rounded-md border border-neutral-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    />
                  ) : field.type === "email" ? (
                    <input
                      type="email"
                      value={field.value}
                      onChange={(e) =>
                        onFieldChange(field.name, e.target.value)
                      }
                      placeholder={field.placeholder}
                      className={`w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-1 ${
                        errors[field.name]
                          ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                          : "border-neutral-300 focus:border-blue-500 focus:ring-blue-500"
                      }`}
                    />
                  ) : (
                    <ModalInput field={field} onFieldChange={onFieldChange} />
                  )}
                  {errors[field.name] && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors[field.name]}
                    </p>
                  )}
                </div>
              ))}
            </div>

            <ModalActions
              hasFilters={hasFilters}
              onSearch={onSearch}
              onClear={onClear}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
